import React from 'react';

import { IntegrationBenefitsSkeleton } from '../IntegrationBenefits';

export const IntegrationBenefitsBoxSkeleton = () => {
  return (
    <div className="box flex flex-col gap-16 border-0 bg-background-primary-default">
      <IntegrationBenefitsSkeleton />
    </div>
  );
};
